<capra-avatar
  *ngIf="avatar"
  class="user-avatar"
  type="user"
  size="small"
  [options]="avatar"
></capra-avatar>
<div *ngIf="!avatar" class="avatar-container" [class.disabled]="isExternalDomain && !externalSharingEnabled">
  <capra-icon
    class="user-avatar avatar-icon"
    icon="icon-avatar"
  ></capra-icon>
</div>
<div class="user-details" [class.disabled]="isExternalDomain && !externalSharingEnabled">
  <div class="user-name">{{ name }}</div>
  <div class="user-email">{{ email }}</div>
</div>
<capra-compat-tooltip-wrapper
  *ngIf="isExternalDomain"
  class="external-badge-tooltip"
  [tooltipContent]="externalSharingEnabled ? externalBadgeTooltipText : externalErrorTooltipText"
  tooltipPlacement="bottom"
>
  <capra-badge
    class="external-badge"
    *ngIf="externalSharingEnabled"
    [text]="'EXTERNAL'"
    [icon]="'icon-new-tab'"
    type="dark-yellow"
  ></capra-badge>
  <capra-icon
    *ngIf="!externalSharingEnabled"
    icon="icon-warning"
    class="external-sharing-error"
  ></capra-icon>
</capra-compat-tooltip-wrapper>
<capra-icon-button *ngIf="showCloseBtn" icon="icon-close" class="close-button" (clicked)="closeBtnClicked.emit()"></capra-icon-button>
